<template>
  <div class="container">
    <div class="main">
      <div class="title" > DIXCEL中国关于整顿闲鱼的声明 </div>
      <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2018-12-26</div>

      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2018_12_26/img1.png')"
          fit="fit">
        </el-image>
      </div>
               
      
    </div>
  </div>
</template>


<script>
    export default {
      data() {
        return{

        }
      }
    }
  </script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}
  .title {
    color :#ab191d;
    text-align:center;
    margin-bottom 10px
  }


</style>